// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__27Cyb","list":"BalanceDue_list__2jUUl","listRow":"BalanceDue_listRow__1YAs7","total":"BalanceDue_total__U9Qct"};